/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
     CollectionActivityFullFromJSONTyped,
     CollectionActivityFullWithoutTracksFromJSONTyped,
     TrackActivityFullFromJSONTyped
} from './';

/**
 * 
 * @export
 * @interface ActivityFull
 */
export interface ActivityFull {
    /**
     * 
     * @type {string}
     * @memberof ActivityFull
     */
    timestamp: string;
    /**
     * 
     * @type {string}
     * @memberof ActivityFull
     */
    itemType: ActivityFullItemTypeEnum;
    /**
     * 
     * @type {object}
     * @memberof ActivityFull
     */
    item: object;
    /**
     * 
     * @type {string}
     * @memberof ActivityFull
     */
    _class: string;
}


/**
 * @export
 */
export const ActivityFullItemTypeEnum = {
    Track: 'track',
    Playlist: 'playlist'
} as const;
export type ActivityFullItemTypeEnum = typeof ActivityFullItemTypeEnum[keyof typeof ActivityFullItemTypeEnum];


/**
 * Check if a given object implements the ActivityFull interface.
 */
export function instanceOfActivityFull(value: object): value is ActivityFull {
    let isInstance = true;
    isInstance = isInstance && "timestamp" in value && value["timestamp"] !== undefined;
    isInstance = isInstance && "itemType" in value && value["itemType"] !== undefined;
    isInstance = isInstance && "item" in value && value["item"] !== undefined;
    isInstance = isInstance && "_class" in value && value["_class"] !== undefined;

    return isInstance;
}

export function ActivityFullFromJSON(json: any): ActivityFull {
    return ActivityFullFromJSONTyped(json, false);
}

export function ActivityFullFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActivityFull {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    if (!ignoreDiscriminator) {
        if (json['_class'] === 'collection_activity_full') {
            return CollectionActivityFullFromJSONTyped(json, true);
        }
        if (json['_class'] === 'collection_activity_full_without_tracks') {
            return CollectionActivityFullWithoutTracksFromJSONTyped(json, true);
        }
        if (json['_class'] === 'track_activity_full') {
            return TrackActivityFullFromJSONTyped(json, true);
        }
    }
    return {
        
        'timestamp': json['timestamp'],
        'itemType': json['item_type'],
        'item': json['item'],
        '_class': json['class'],
    };
}

export function ActivityFullToJSON(value?: ActivityFull | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'timestamp': value.timestamp,
        'item_type': value.itemType,
        'item': value.item,
        'class': value._class,
    };
}

